import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LodashService } from './lodash.service';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  configSettings: any = {
    enableNotifications: true,
    enableHttps: true,
    apiHost: environment.baseApiUrl,
    apiHostBg: 'https://egi-api-bg.epiphanex.com',
    apiHostCbr: 'https://api.carbrewer.com',
    apiHostHs: environment.baseApiUrl,
    //apiHostHs: 'hs-api.epiphanex.com',
    restBaseUrl: '',
    authKey: '',
    apiKey: '',
    // apiKey: '629ea048ef635147a565f76a116ed3cc',
    // customerKey: '55914241a751322804341fc97a7e4637',
    //apiKey: '629ea048ef635147a565f76a116ed3cc',
    //customerKey: '55914241a751322804341fc97a7e4637',
    customerKey: 'c49a28b65315463f80538e8aca0b4635', //Edifice
    //customerKey: '33fdb1ad2d884b58a10ae5e1d8b6a0f7' //GrowPodium

    currentSiteCode: 'dc1',
  };

  constructor() {
    this.configSettings = _.extend(
      {},
      this.configSettings,
      JSON.parse(localStorage.getItem('configSettings')),
      { apiHost: environment.baseApiUrl, apiHostHs: environment.baseApiUrl },
    );
  }

  setObject = function (key: string, val: object) {
    localStorage.setItem(key, JSON.stringify(val));
  };
  set = function (configSettings: object) {
    //console.log('Trying to save configSettings', configSettings);
    this.configSettings = _.extend(this.configSettings, configSettings);
    this.setObject('configSettings', configSettings);
  };
  get = function () {
    //console.log('configSettings',this.configSettings);
    return this.configSettings;
    //return JSON.parse(localStorage.getItem('configSettings'));
  };
  apiUrl = function () {
    const c = this.configSettings;
    return c.apiHost + c.restBaseUrl;
  };
  apiUrlBg = function () {
    const c = this.configSettings;
    return c.apiHostBg + c.restBaseUrl;
  };
  apiUrlCbr = function () {
    const c = this.configSettings;
    return c.apiHostCbr + c.restBaseUrl;
  };
  apiUrlHs = function () {
    const c = this.configSettings;
    //console.log('in apiUrlCbr', this.configSettings);
    return c.apiHostHs + c.restBaseUrl;
  };
}
